// components/Layout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-gray-200 font-sans">
      <div className="w-full max-w-6xl mx-auto p-4 sm:p-6 md:p-8">
        <Header />
        <main className="my-8">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
